import { $host } from './index';

export const fetchAppointmentCancellations = async (params) => {
  const { data } = await $host.post('web/appointment_cancellations', { params });
  return data;
};

